import { SingleLineText } from '@bloomays-lib/ui.shared';

import { styled } from '@mui/material/styles';

export type DetailsSectionCardProps = {
  title: string;
  details?: string;
  text?: string;
};

const DetailsSectionCard = ({ title = '', details = '', text }: DetailsSectionCardProps) => {
  return (
    <Container>
      <div>
        <TitleSingleLineText text={title} variant="heading8" />
        <TextDetailsSingleLineText text={details} />
      </div>
      <SingleLineText text={text} />
    </Container>
  );
};

export default DetailsSectionCard;
export { DetailsSectionCard };

const TitleSingleLineText = styled(SingleLineText)(({ theme }) => ({
  color: 'rgb(54, 54, 54)',
}));

const TextDetailsSingleLineText = styled(SingleLineText)(({ theme }) => ({
  color: theme.palette.neutral[50],
}));

const Container = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.neutral[10],
  borderLeft: `4px solid ${theme.palette.blue[60]}`,
  display: 'flex',
  flexFlow: 'column nowrap',
  justifyContent: 'space-between',
  padding: '1em 1.5em',
  margin: '2em auto',
  textAlign: 'left',
}));
